import {
  SelectionText
} from "./chunk-W2BRCVY6.mjs";
import {
  stopPropagation
} from "./chunk-ZOV2YOCF.mjs";

// src/shortcuts.ts
function shortcuts(e, indentWidth = 2) {
  const api = new SelectionText(e.target);
  const code = (e.code || e.nativeEvent.code).toLocaleLowerCase();
  const indent = " ".repeat(indentWidth);
  if (code === "tab") {
    stopPropagation(e);
    if (api.start === api.end) {
      if (e.shiftKey) {
        api.lineStarRemove(indent);
      } else {
        api.insertText(indent).position(api.start + indentWidth, api.end + indentWidth);
      }
    } else if (api.getSelectedValue().indexOf("\n") > -1 && e.shiftKey) {
      api.lineStarRemove(indent);
    } else if (api.getSelectedValue().indexOf("\n") > -1) {
      api.lineStarInstert(indent);
    } else {
      api.insertText(indent).position(api.start + indentWidth, api.end);
    }
    api.notifyChange();
  } else if (code === "enter") {
    stopPropagation(e);
    const indent2 = `
${api.getIndentText()}`;
    api.insertText(indent2).position(api.start + indent2.length, api.start + indent2.length);
    api.notifyChange();
  } else if (code && /^(quote|backquote|bracketleft|digit9|comma)$/.test(code) && api.getSelectedValue()) {
    stopPropagation(e);
    const val = api.getSelectedValue();
    let txt = "";
    switch (code) {
      case "quote":
        txt = `'${val}'`;
        if (e.shiftKey) {
          txt = `"${val}"`;
        }
        break;
      case "backquote":
        txt = `\`${val}\``;
        break;
      case "bracketleft":
        txt = `[${val}]`;
        if (e.shiftKey) {
          txt = `{${val}}`;
        }
        break;
      case "digit9":
        txt = `(${val})`;
        break;
      case "comma":
        txt = `<${val}>`;
        break;
    }
    api.insertText(txt);
    api.notifyChange();
  }
}

export {
  shortcuts
};
//# sourceMappingURL=chunk-XJWZA7KQ.mjs.map